import React from 'react';
import { volunteering } from '../../portfolio';
import { ExternalLink } from 'lucide-react';

const Volunteering = () => {
  return (
    <section className="section">
      <div className="section-header">
        <h1 className="section-title">Volunteering</h1>
        <p className="section-subtitle">Community service and leadership roles.</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
        {volunteering.map((v, idx) => (
          <div key={idx} className="list-card" style={{ padding: '32px', background: 'var(--surface)', borderRadius: 'var(--radius)', border: '1px solid var(--border)' }}>
            <div className="list-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <div>
                <h4 style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-1)', marginBottom: '8px' }}>{v.role}</h4>
                <div style={{ fontSize: '15px', color: 'var(--text-1)', fontWeight: 500 }}>{v.organization}</div>
              </div>
              {v.certificateUrl && (
                <a href={v.certificateUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '13px', color: 'var(--text-2)', display: 'flex', alignItems: 'center', gap: '6px', background: 'var(--bg)', padding: '8px 16px', borderRadius: '6px', border: '1px solid var(--border)', textDecoration: 'none', transition: 'background 0.2s' }}>
                  Certificate <ExternalLink size={14} />
                </a>
              )}
            </div>
            <div style={{ fontSize: '14px', color: 'var(--text-3)', marginBottom: '24px' }}>{v.duration} • {v.location}</div>
            <ul style={{ paddingLeft: '24px', margin: 0, color: 'var(--text-2)', fontSize: '15px', lineHeight: 1.7 }}>
              {v.description.map((item, i) => (
                <li key={i} style={{ marginBottom: '8px' }}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Volunteering;
